import styled from "@emotion/styled";
import { TopAppBar } from "@rmwc/top-app-bar";

// need to type as any, current limitation with @emotion/styled
const TopAppBarContainer: any = styled(TopAppBar)`
  height: 64px;
  background: var(--mdc-theme-primary);
  opacity: 0.95;
  background-image: linear-gradient(to right, var(--mdc-theme-primary), #55573a);
`;

export default TopAppBarContainer;
